"use strict";

/**
* Всплывающее сообщение.
* 
* @class WebAccess.components.notifications.Toast
* @since 5.0.0.4305
* @extends BaseObject
* @property {object} [opt_settings] Параметры уведомления
* @example
* // Показать всплывающее сообщение с текстом «Hello world».
* var toast = new WA.CMP.NTF.Toast()
* toast.showMessage("Hello world");
*/
(function (global) {
  var Toast = BaseObject.extend({
  
    init: function (opt_settings) {      
      this._super(opt_settings);

      if ($.isPlainObject(opt_settings)) {
        $.extend(this, opt_settings);
      };

      $.toast.config.align = this.align;      
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    
    className: 'Toast',
    align: 'right',
    id: null,

    /**
    * Показать сообщение с текстовой информацией.
    *
    * @method  WebAccess.components.notifications.Toast#showMessage
    * @param {string} message Текст сообщения
    * @param {boolean} [opt_sticky] Признак закрытия сообщения по кнопке «Закрыть». Возможные значения: true, false
    * @param {integer} [opt_duration] Продолжительность показа сообщения
    * @return {WebAccess.components.notifications.Toast} Объект класса Toast.
    */
    showMessage: function (msg, opt_sticky, opt_duration) {      
      this.show(msg, "info", opt_sticky, opt_duration)
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показывает сообщение об успешно выполненной операции.
    *
    * @method  WebAccess.components.notifications.Toast#showSuccess
	* @param {string} message Текст сообщения
    * @param {boolean} [opt_sticky] Признак закрытия сообщения по кнопке «Закрыть». Возможные значения: true, false
    * @param {integer} [opt_duration] Продолжительность показа сообщения
    * @return {WebAccess.components.notifications.Toast} Объект класса Toast.
    */
    showSuccess: function (msg, opt_sticky, opt_duration) {
      // В JQuery.Toast есть опечатка в Success, поэтому здесь используется именно succecc!
      this.show(msg, "succecc", opt_sticky, opt_duration)
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать сообщение с предупреждением.
    *
    * @method  WebAccess.components.notifications.Toast#showWarning
    * @param {string} message Текст сообщения
    * @param {boolean} [opt_sticky] Признак закрытия сообщения по кнопке «Закрыть». Сообщение требуется закрыть вручную. Возможные значения: true, false  
    * @param {integer} [opt_duration] Продолжительность показа сообщения    
    * @return {WebAccess.components.notifications.Toast} Объект класса Toast.
    */
    showWarning: function (msg, opt_sticky, opt_duration) {
      this.show(msg, "warning", opt_sticky, opt_duration)
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать сообщение об ошибке.
    *
    * @method  WebAccess.components.notifications.Toast#showError
    * @param {string} message Текст сообщения
    * @param {boolean} [opt_sticky] Признак закрытия сообщения по кнопке «Закрыть». Возможные значения: true, false
    * @param {integer} [opt_duration] Продолжительность показа сообщения
    * @return {WebAccess.components.notifications.Toast} Объект класса Toast.
    */
    showError: function (msg, opt_sticky, opt_duration) {
      this.show(msg, "error", opt_sticky, opt_duration)
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать сообщение.
    *
    * @method  WebAccess.components.notifications.Toast#show
    * @param {string} msg Текст сообщения
    * @param {MESSAGE_TYPE} [opt_type] Тип сообщения (ошибка, предупреждение, информация)
    * @param {boolean} [opt_sticky] Признак закрытия сообщения по кнопке «Закрыть». Возможные значения: true, false
    * @param {number} [opt_duration] Продолжительность показа сообщения
    * @return {WebAccess.components.notifications.Toast} Объект класса Toast.
    */
    show: function (msg, opt_type, opt_sticky, opt_duration) {
      this.id = $.toast(msg, {
        type: opt_type || 'success',
        sticky: opt_sticky || 'false',
        duration: opt_duration || 2000,
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
   
    /**
    * Скрыть последнее сообщение.
    *
    * @method  WebAccess.components.notifications.Toast#hide        
    * @return {WebAccess.components.notifications.Toast} Объект класса Toast.
    * @since 5.0.0.4312
    */
    hide: function () {
      if (this.id) $("#"+this.id).remove();
      else global.Toast.hideAll();
      return this;
    }
  });

  global.Toast = Toast;

  /**
  * Скрыть все сообщения.
  *
  * @function WebAccess.components.notifications.Toast.hideAll
  * @static
  * @since 5.0.0.4312
  */
  global.Toast.hideAll = function () {
    $("ul.toast.active li").remove();
  }

})(window.WebAccess.components.notifications);